import { render, staticRenderFns } from "./HelpdeskRead.vue?vue&type=template&id=5caf4f80"
import script from "./HelpdeskRead.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskRead.ts?vue&type=script&lang=ts&external"
import style0 from "./HelpdeskRead.vue?vue&type=style&index=0&id=5caf4f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports